import { useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import CreditUsage from "../../ui/CreditUsage";

export default function AdminCreditUsage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const creditType =
    new URLSearchParams(window.location.search).get("creditType") || "Grader";

  const { user } = useContext(AuthContext);
  const instituteId = user?.instituteId;

  const breadcrumbs = [
    { name: "Home", path: "/admin", id: "home" },
    {
      name: "Manage Institute",
      path: "/admin/manage-institute",
      id: "manage-institute",
    },
    {
      name: `${
        creditType === "Grader" ? "Grading" : "Question Bank"
      } Credit Usage Details`,
      path: `/admin/manage-institute/grading-credit-usage/?creditType=${creditType}`,
      isLast: true,
      id: `grading-credit-usage`,
    },
  ];

  return (
    <CreditUsage
      role="admin"
      instituteId={instituteId}
      creditType={creditType}
      showTypeSelector={false}
      showInstituteName={false}
      breadcrumbs={breadcrumbs}
    />
  );
}
